import { hasHidden, valueOrNull } from "@/shared/value";
import { useSuspenseQuery } from "@apollo/client";
import { GET_BPM_ROLE_ASSIGNMENT_TO_EDIT } from "../api/get-bpm-role-assignment-to-edit";
import { FieldsType } from "./types";

export function useBpmRole({ id }: { id?: string }) {
  const { data } = useSuspenseQuery(GET_BPM_ROLE_ASSIGNMENT_TO_EDIT, {
    variables: { id: id as string },
    skip: !id,
  });

  const entity: Partial<FieldsType> = data
    ? {
        hierarchyElement: data?.getHrRoleAssignmentById.hierarchyElement
          .id as string,
        person: valueOrNull(data?.getHrRoleAssignmentById.person)?.id as string,
        role: data?.getHrRoleAssignmentById.role.id as string,
        id: data?.getHrRoleAssignmentById.id as string,
      }
    : {};

  return {
    entity,
    hasHiddenFields: hasHidden([data?.getHrRoleAssignmentById.person]),
  };
}
